export const environment = {
  production: true,
  appVersion: 'v1',
  apiUrl: 'https://gecontrolapi.sistemasgrupoexito.com.br',
  angularUrl: 'https://gecontrol.sistemasgrupoexito.com.br',
  pncpUrl: 'https://pncp.gov.br/app',
};
